module.exports = __webpack_public_path__ + "media/images/shield-exclamation-abc7e62e7b04924b99ab9dd49553e995.png";